module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-sm btn-confirm",
    class: {
      'mark-disabled': !_vm.isActive
    },
    attrs: {
      "disabled": !_vm.isActive
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(_vm._s(_vm.t('Download')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b9bf164!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/DownloadComponent.vue
// module id = 1230
// module chunks = 2